import { registerComponent } from '../../lib/vulcan-lib/components';
import React from 'react';
import CollectionsPage from "./CollectionsPage";

const EAIntroCurriculum = () => {
  return <CollectionsPage documentId={'MobebwWs2o86cS9Rd'} />
};

export default registerComponent('EAIntroCurriculum', EAIntroCurriculum);



